import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import { Typography } from "@mui/material";
import { Avatar, Button, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import "./Header.css";
import { useHistory} from "react-router-dom"



const Header = ({ children, hasHiddenAuthButtons }) => {
  const history = useHistory();
  
  
  const handleLogout = () => {
    localStorage.clear();
    window.location.reload();
  };
   const isloggedIn = localStorage.getItem("username")
  if(hasHiddenAuthButtons)
 {
   return (
      <Box className="header">
        <Box className="header-title">
            <img src="logo_light.svg" alt="QKart-icon"></img>
        </Box>
        <Button
          className="explore-button"
          startIcon={<ArrowBackIcon />}
          variant="text"
          onClick = {()=> history.push("/")}
        >
          BACK TO EXPLORE
        </Button>
      </Box>
    )};

    return(
      <Box className="header">
        <Box className="header-title">
            <img src="logo_light.svg" alt="QKart-icon"></img>
        </Box>
        {children}
        <Stack direction="row" spacing={1} alignItems="center" >
        {
          isloggedIn?
          <>
          <Avatar src="../../public/avatar.png" alt={isloggedIn} />
          <span>{localStorage.getItem("username")}</span>
          <Button onClick={handleLogout}>LOGOUT</Button>
          </>
          :
          <>           
            <Button  onClick={()=> history.push("/login")}> LOGIN</Button>
            <Button variant="contained" onClick={()=> history.push("/register")}
            >REGISTER</Button>
          </>
        }
        
        </Stack>
      </Box>
        
    )
};

export default Header;
